import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="contact">
      {/* Upper Section - Light Grey */}
      <div className="footer-upper">
        <div className="footer-upper-content">
          {/* Policy Links */}
          <div className="footer-policy-links">
            <div className="policy-links-row">
              <a href="#contact">Contact Us</a>
              <span className="separator">|</span>
              <Link to="/security">Security</Link>
              <span className="separator">|</span>
              
              <Link to="/terms">Terms of Service</Link>
              <span className="separator">|</span>
              <Link to="/privacy">Privacy Policy</Link>
              <span className="separator">|</span>
              
            </div>
            <div className="policy-links-row">
              <Link to="/cookie">Cookie Policy</Link>
              <span className="separator">|</span>
              <Link to="/abuse">Abuse Policy</Link>
            </div>
          </div>
          
          {/* Social Links */}
          <div className="footer-social-links">
            <a href="https://x.com/fractallogy" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Follow us on X">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/fractallogy" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Follow us on LinkedIn">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Lower Section - Dark Blue */}
      <div className="footer-lower">
        <div className="footer-lower-content">
          {/* Company Logo */}
          <div className="footer-logo">
            <img src="/images/logo.jpg" alt="Fractallogy Logo" />
            
          </div>
          
          {/* Copyright */}
          <p className="footer-copyright">
            © 2026, Fractallogy All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
